import React from 'react';
import { WebsiteDesignProps } from './types';
import { Shield, Target, Award } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MilitaryAcademy: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Defense Academy";

    return (
        <div className="bg-[#4b5320] text-white min-h-screen font-mono selection:bg-yellow-500 selection:text-black">
            {/* Camo Pattern Overlay */}
            <div className="fixed inset-0 pointer-events-none opacity-10 mix-blend-multiply" style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='200' height='200' viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h200v200H0z' fill='%233a4018'/%3E%3Cpath d='M145.3 124.6c-4.9-5.4-13.4-3.8-19.6 1.6-4.9 4.3-8.8 11.2-5.4 17.5 3.3 6.1 11.8 7.3 17.1 3.5 6.9-4.9 10.6-15.5 7.9-22.6zM46.7 44.2c-5.7 3.3-6.2 11.3-1.6 15.7 4.8 4.6 13.9 4.3 17.5-2 2.8-4.9 1-11.8-4-13.9-3.8-1.6-8.7.1-11.9.2z' fill='%235d652e'/%3E%3C/svg%3E")`
            }}></div>

            <nav className="relative z-10 border-b border-[#ffd700]/30 bg-[#3a4018] px-8 py-4 flex justify-between items-center">
                <div className="flex items-center gap-3">
                    <Shield className="text-[#ffd700]" fill="currentColor" fillOpacity={0.2} />
                    <span className="text-xl font-bold uppercase tracking-widest text-white">{schoolName}</span>
                </div>
                <div className="hidden md:block text-[#ffd700] text-xs font-bold uppercase tracking-[0.2em]">
                    Duty • Honor • Country
                </div>
                <Button variant="outline" className="border-[#ffd700] text-[#ffd700] hover:bg-[#ffd700] hover:text-[#3a4018] uppercase text-xs font-bold tracking-widest rounded-none">
                    Cadet Portal
                </Button>
            </nav>

            <header className="relative py-24 px-8 container mx-auto z-10 text-center">
                <div className="w-24 h-1 bg-[#ffd700] mx-auto mb-8"></div>
                <h1 className="text-5xl md:text-7xl font-bold uppercase mb-8 leading-tight drop-shadow-lg">
                    Forging <br/> Leaders.
                </h1>
                <p className="text-lg text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
                    A premier institution dedicated to academic excellence, physical rigor, and moral character. Preparing the guardians of tomorrow.
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                    <Button className="bg-[#ffd700] text-[#3a4018] hover:bg-yellow-400 font-bold uppercase tracking-widest px-8 rounded-none h-14">
                        Admissions
                    </Button>
                    <Button variant="outline" className="border-white text-white hover:bg-white/10 font-bold uppercase tracking-widest px-8 rounded-none h-14">
                        Athletics
                    </Button>
                </div>
            </header>

            <section className="bg-[#3a4018] py-16 border-t border-[#ffd700]/20 relative z-10">
                <div className="container mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                     <div className="border border-[#ffd700]/30 p-8 hover:bg-[#4b5320] transition-colors">
                         <Target className="text-[#ffd700] mb-4" size={32} />
                         <h3 className="text-xl font-bold uppercase mb-2">Focus</h3>
                         <p className="text-gray-400 text-sm">Unwavering attention to the mission and academic goals.</p>
                     </div>
                     <div className="border border-[#ffd700]/30 p-8 hover:bg-[#4b5320] transition-colors">
                         <Shield className="text-[#ffd700] mb-4" size={32} />
                         <h3 className="text-xl font-bold uppercase mb-2">Integrity</h3>
                         <p className="text-gray-400 text-sm">Adherence to the highest moral and ethical principles.</p>
                     </div>
                     <div className="border border-[#ffd700]/30 p-8 hover:bg-[#4b5320] transition-colors">
                         <Award className="text-[#ffd700] mb-4" size={32} />
                         <h3 className="text-xl font-bold uppercase mb-2">Excellence</h3>
                         <p className="text-gray-400 text-sm">Striving for perfection in every endeavor, from field to classroom.</p>
                     </div>
                </div>
            </section>
        </div>
    );
};

export default MilitaryAcademy;
